import { createAccessLevel } from 'shared/domain/issue/mapping/accessLevel/model/createAccessLevel';
import { accessLevelModelToOnDropdownView } from 'shared/domain/issue/mapping/accessLevel/toOnView/accessLevelModeltoOnDropdownView';
import {
  AccessLevelOnDropdownView,
  UserAccess,
} from 'shared/domain/issue/mapping/accessLevel/toOnView/types';
import {
  SubmitterOnAccessChangeView,
  TargetUserOnAccessChangeView,
} from 'shared/domain/user/types/view';

export function getAccessLevelOnDropdownView({
  issueUserAccesses,
  submitter,
  targetUser,
  siteId,
  processId,
}: {
  issueUserAccesses: UserAccess[];
  submitter: SubmitterOnAccessChangeView;
  targetUser: TargetUserOnAccessChangeView;
  siteId: string;
  processId: string;
}): AccessLevelOnDropdownView {
  const submitterAccessLevel = createAccessLevel(
    issueUserAccesses,
    submitter._id,
    submitter.role
  );
  const userAccessLevel = createAccessLevel(
    issueUserAccesses,
    targetUser._id,
    targetUser.role
  );
  return accessLevelModelToOnDropdownView({
    submitterAccessLevel,
    submitter,
    targetUser,
    userAccessLevel,
    siteId,
    processId,
  });
}
